import { IConfirmationLocationState } from 'src/components/BookingFlow/ReservationConfirm/ReservationConfirm';

export const redirectAfterSendReservation = (state: IConfirmationLocationState, customSuccesLink?: string): boolean => {
    if (customSuccesLink) {
        const hasAnyBlocked = state.Reservations!.some(r => r.Blocked);

        if (!hasAnyBlocked) {
            const queryParams = createQueryParams(state);
            const divider = customSuccesLink.includes('?') ? '&' : '?';
            window.location.href = `${customSuccesLink}${divider}${queryParams}`;
            return true;
        }
    }

    return false;
}


const createQueryParams = (state: IConfirmationLocationState): string => {
    const params = new URLSearchParams();
    const reservation = state.Reservations![0];

    params.append('instanceUrl', window.location.hostname);

    if (reservation.CalendarId) {
        params.append('calendarId', reservation.CalendarId.toString());
    }

    params.append('serviceId', reservation.ServiceId.toString());
    params.append('reservationId', reservation.Id.toString());

    if (state.clientKey) {
        params.append('clientKey', state.clientKey);
    }
    if (reservation.User) {
        params.append('email', reservation.User.Email);
        params.append('phone', reservation.User.Phone);
        params.append('fullName', reservation.User.Name);
    }

    params.append('personCount', reservation.PersonCount.toString());

    return params.toString();
}